import React from "react";

class StatusBar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    render() {

        let minutes = Math.floor(this.props.time / 60);


        let minutes1 = minutes % 10;
        let minutes2 = Math.floor(minutes / 10);

        if (minutes2 > 5) {
            minutes2 = minutes2 - (6 * Math.floor(minutes2 / 6));
        }

        let hours = Math.floor(minutes / 60);
        let hours2 = "";

        if (hours > 0) {
            hours2 = hours + ":";
        }

        let seconds1 = this.props.time % 10;
        let seconds2 = Math.floor(this.props.time / 10);

        if (seconds2 > 5) {
            seconds2 = seconds2 - (6 * Math.floor(seconds2 / 6));
        }

        return (
            <div className="status-bar">
                <div className="hud-interactions modal-container">
                    <div className="modal-content">
                        <button className="icon-button" title="Highlight available tiles" id="button-available-tiles" onClick={this.props.showAvailable}>
                            {/* <div className="icon-button-content"> */}
                                <i className="far fa-eye display-none" id="available-tiles-active" />
                                <i className="far fa-eye-slash" id="available-tiles-inactive" />
                            {/* </div> */}
                        </button>
                        <button className="icon-button icon-button-inactive" title="Hint" id="button-hint" onClick={this.props.hint}>
                            <div className="icon-button-cooldown" id="button-hint-cooldown" />
                            {/* <div className="icon-button-content"> */}
                                <i className="far fa-lightbulb" />
                            {/* </div> */}
                        </button>
                        <button className="icon-button" title="Shuffle tiles" id="button-shuffle" onClick={this.props.shuffler}>
                            {/* <div className="icon-button-content"> */}
                                <i className="fas fa-random" />
                            {/* </div> */}
                        </button>
                        <div className="shuffle-pip" id="shuffle-pip-1"></div>
                        <div className="shuffle-pip" id="shuffle-pip-2"></div>
                    </div>
                </div>
                <div className="hud-settings modal-container">
                    <div className="modal-content">
                        <button className="icon-button" title="Settings" id="button-settings" data-modalid="modal-settings" onClick={this.props.openModal}>
                            {/* <div className="icon-button-content"> */}
                                <i className="fas fa-cog" />
                            {/* </div> */}
                        </button>
                        <button className="icon-button" title="About" id="button-about" data-modalid="modal-about" onClick={this.props.openModal}>
                            {/* <div className="icon-button-content"> */}
                                ?
                            {/* </div> */}
                        </button>
                        <a id="button-donate" title="Support me on Ko-Fi" className="icon-button" href='https://ko-fi.com/M4M2XMIW' target='_blank' rel="noopener noreferrer">
                            <div className="icon-button-content">
                                <i className="fas fa-mug-hot" />
                            </div>
                        </a>
                    </div>
                </div>
                <div className="hud-timer modal-container">
                    <div className="modal-content">
                        <span className="icon-button" title="Time elapsed" id="timer">
                            <div className="icon-button-content">
                                <span id="time">{hours2}{minutes2}{minutes1}:{seconds2}{seconds1}</span>
                            </div>
                        </span>
                        <span className="icon-button" title="Availalbe matches" id="available-matches">
                            <div className="icon-button-content">
                                <i className="far fa-clone" />&nbsp;{this.props.matches}
                            </div>
                        </span>
                    </div>
                </div>
            </div>
        );
    }
}

export default StatusBar;